import { useContext } from 'react';
import { LoaderContext } from 'context';

export function useLoaderContext() {
	return useContext(LoaderContext);
}
